import { FaMobileAlt, FaDesktop, FaTabletAlt, FaUserFriends, FaCloud } from "react-icons/fa";

const featuresData = [
  {
    heading: "Simple to use",
    description: "No training required.",
    icon: FaMobileAlt,
    color: "#2dd4bf" // teal-400
  },
  {
    heading: "No AMC",
    description: "Support free reliable software",
    icon: FaDesktop,
    color: "#fb923c" // orange-400
  },
  {
    heading: "Online-Offline",
    description: "Works even when internet is not present",
    icon: FaTabletAlt,
    color: "#a855f7" // purple-500
  },
  {
    heading: "User-Friendly Interface",
    description: "Accessible and intuitive for lab owners, technicians",
    icon: FaUserFriends,
    color: "#60a5fa" // blue-400
  },
  {
    heading: "Enhance Patients Experience",
    description: "Empowering patients to stay informed and take control of their health on easily accessible whatsapp",
    icon: FaCloud,
    color: "#4ade80" // green-400
  }
];

export default featuresData;